import {useCSMAccessCheck} from "./hooks/useCSMAccessCheck";
import CSMApp from "./CSMApp";
import App from "./App";
import "./App.css";
import CssBaseline from "@mui/material/CssBaseline";
import {Tooltip} from '@base-ui/react/tooltip'
import {BrowserRouter} from "react-router-dom";
import {YuJaGlobalStateProvider} from "./utils/LoadingContext";
import {YuJaEventBusProvider} from "./components/standardization/YuJaEventBusProvider";

export default function AppSwitcher() {
    const {isCSMSystem} = useCSMAccessCheck();
    return (
        <BrowserRouter>
            <Tooltip.Provider delay={0} closeDelay={50}>
                <CssBaseline/>
                <YuJaGlobalStateProvider>
                    <YuJaEventBusProvider>
                        {isCSMSystem() ? <CSMApp/> : <App/>}
                    </YuJaEventBusProvider>
                </YuJaGlobalStateProvider>
            </Tooltip.Provider>
        </BrowserRouter>
    );
}